/**
 * Not Found Page (404)
 * This is a special Next.js file for handling 404 errors
 */

import Link from "next/link";
import { Header } from "@/components/homepage/Header";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col bg-white dark:bg-gray-900">
      <Header />
      
      <main className="flex flex-1 items-center justify-center p-6">
        <div className="text-center">
          <h1 className="mb-4 text-6xl font-bold text-gray-900 dark:text-white">
            404
          </h1>
          <h2 className="mb-6 text-2xl font-semibold text-gray-700 dark:text-gray-300">
            페이지를 찾을 수 없습니다
          </h2>
          <p className="mb-8 text-gray-600 dark:text-gray-400">
            This is not-found page
          </p>
          
          <Link href="/">
            <Button
              size="lg"
              className="gap-2 bg-brand-600 hover:bg-brand-700"
            >
              <Home className="h-5 w-5" />
              홈으로 돌아가기
            </Button>
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
}

